import {
  CreateContextProvider,
  Form,
  SaveButton,
  useCreateController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../resource';
import BannerForm from './BannerForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const CreateBanner = ({ onClose }: { onClose: () => void }) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useCreateController({
    resource: Resources.smallBanners,
    mutationOptions: {
      onSuccess: () => {
        notify(t('module.smallBanners.createSuccess'), { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        const errorCode = error?.body?.code || error?.code;
        switch (errorCode) {
          default:
            notify(error.message, { type: 'error' });
            break;
        }
      },
    },
  });

  return (
    <CreateContextProvider value={controller}>
      <Form
        disableInvalidFormNotification
        defaultValues={{
          showButton: true,
          isInternalRoute: false,
          enButtonText: '',
          zhButtonText: '',
        }}
      >
        <DialogTitle>{t('module.smallBanners.create')}</DialogTitle>
        <DialogContent>
          <BannerForm isCreate />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="small-banners" action="create">
            <SaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </CreateContextProvider>
  );
};

export default CreateBanner;
